var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('ejs-toast',{ref:"toastRef",attrs:{"id":"globalToast","position":_vm.position}}),_c('div',{attrs:{"id":"mainSpinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }